export const pago_movil_bank: Array<{ codeBank: string; nameBank: string }> = [
    /*{
        //codeBank: '0001',
        //nameBank: 'Banco Central de Venezuela'
    },*/
    {
        codeBank: '0102',
        nameBank: 'Banco de Venezuela S.A.'
    },
    {
        codeBank: '0104',
        nameBank: 'Venezolano de Crédito S.A.'
    },
    {
        codeBank: '0105',
        nameBank: 'Banco Mercantil, C.A'
    },
    {
        codeBank: '0108',
        nameBank: 'Banco Provincial, S.A.'
    },
    {
        codeBank: '0114',
        nameBank: 'Bancaribe C.A.'
    },
    {
        codeBank: '0115',
        nameBank: 'Banco Exterior C.A.'
    },
    {
        codeBank: '0116',
        nameBank: 'Banco Occidental de Descuento, C.A.'
    },
    {
        codeBank: '0128',
        nameBank: 'Banco Caroní C.A.'
    },
    {
        codeBank: '0134',
        nameBank: 'Banesco S.A.C.A.'
    },
    {
        codeBank: '0137',
        nameBank: 'Banco Sofitasa C.A.'
    },
    {
        codeBank: '0138',
        nameBank: 'Banco Plaza C.A.'
    },
    {
        codeBank: '0146',
        nameBank: 'Banco de la Gente Emprendedora C.A.'
    },
    {
        codeBank: '0149',
        nameBank: 'Banco del Pueblo Soberano, C.A.'
    },
    {
        codeBank: '0151',
        nameBank: 'BFC Banco Fondo Común C.A.'
    },
    {
        codeBank: '0156',
        nameBank: 'Banco, C.A.'
    },
    {
        codeBank: '0157',
        nameBank: 'DelSur, C.A.'
    },
    {
        codeBank: '0163',
        nameBank: 'Banco del Tesoro, C.A.'
    },
    {
        codeBank: '0166',
        nameBank: 'Banco Agrícola de Venezuela, C.A'
    },
    {
        codeBank: '0168',
        nameBank: 'Bancrecer, S.A.'
    },
    {
        codeBank: '0169',
        nameBank: 'Mi Banco C.A.'
    },
    {
        codeBank: '0171',
        nameBank: 'Banco Activo, C.A.'
    },
    {
        codeBank: '0172',
        nameBank: 'Bancamiga, C.A.'
    },
    {
        codeBank: '0173',
        nameBank: 'Banco Internacional de Desarrollo, C.A.'
    },
    {
        codeBank: '0174',
        nameBank: 'Banplus, C.A.'
    },
    {
        codeBank: '0175',
        nameBank: 'Banco de la Fuerza Armada Nacional Bolivariana'
    },
    {
        codeBank: '0190',
        nameBank: 'Citibank N.A.'
    },
    {
        codeBank: '0191',
        nameBank: 'Banco Nacional de Crédito, C.A.'
    },
    {
        codeBank: '0601',
        nameBank: 'Instituto Municipal de Crédito Popular'
    }
];
